import axios from 'axios';
import { debounce } from 'lodash';
import React from 'react';
import v4 from 'uuid';
import * as Yup from 'yup';
import URL from '../../../store/path';
import { parseDateFromFormats } from '../../../utilities/parseDate';


export const itemmap = () => ({
    id: v4(),
    dms_id: "",
    uom: "",
    segid: null,
    cid: null,
    status: 1,
    rlb_item_name: "",
    uid_create: "",
    dt_update: "",
    parent_group: "",
    rlb_item_code: "",
    rlb_item_group: "",
    item_wise_sale_ledger: "",
    item_wise_sale_ledger_cd: "",
    item_wise_purchase_ledger: "",
    item_wise_purchase_ledger_cd: "",
    dt_create: "",
    uid_update: "",
})


Yup.addMethod(Yup.date, 'format', parseDateFromFormats);
export const itemmapSchema = Yup.object().shape({

    id: Yup.string()
        .required('This is a Required Field'),
    parent_group: Yup.string()
        .required('Parent Group Required'),
    dms_id: Yup.string()
        .required('DMS ID Required'),

    rlb_item_name: Yup.string()
        .required('RLB Item Name Required'),
    rlb_item_code: Yup.string()
        .required('RLB Item Code Required'),
    rlb_item_group: Yup.string()
        .required('RLB Item Group Required'),
    uom: Yup.string()
        .required('UOM Required'),

    status: Yup.number().integer().nullable(),
    segid: Yup.string().nullable(),
    cid: Yup.string().nullable(),
    txnid: Yup.string().nullable(),
    dt_create: Yup.string().nullable(),
    dt_update: Yup.string().nullable(),
    user_create: Yup.string().nullable(),
    user_update: Yup.string().nullable()

});


export const duplicateCheckItemmapCode = debounce(checkItemmapCode, 500);
function checkItemmapCode(value) {
    if (value.length > 0)
        return axios.post(URL + '/itemmap/exists/' + value, { type: 'checkCode' })
            .then(response => {
                if (response.data === 'duplicate') {
                    console.log("response", response.data)
                    return "Duplicate"
                }
            })
            .catch(error => "")
}


export const duplicateCheckItemmapName = debounce(checkItemmapName, 500);
function checkItemmapName(value) {
    if (value.length > 2)
        return axios.post(URL + '/itemmap/exists/' + value, { type: 'checkName' })
            .then(response => {
                if (response.data === 'duplicate') {
                    console.log("response", response.data)
                    return "Duplicate"
                }
            })
            .catch(error => "")
}


export const searchColumns = [
    {
        Header: <div style={{ textAlign: 'left' }} >PARENT GROUP</div>,
        accessor: 'parent_group',
        Cell: row => <div className='ellipsisDiv' style={{ width: '150px',paddingLeft: "8px" }} title={(row.value && row.value !== undefined && row.value !== null && row.value !== 'NULL' && row.value !== "0" && row.value !== 0) ? row.value : ""}>{(row.value && row.value !== undefined && row.value !== null && row.value !== 'NULL' && row.value !== "0" && row.value !== 0) ? row.value : ""}</div>,
        classNameGet: 'itemmapfilter5',

    },
    {
        Header: <div style={{ textAlign: 'left' }} >DMS ID</div>,
        accessor: 'dms_id',
        Cell: row => <div style={{ textAlign: "left", paddingLeft: "5px" }} title={(row.value && row.value !== undefined && row.value !== null && row.value !== 'NULL' && row.value !== "0" && row.value !== 0) ? row.value : ""}>{(row.value && row.value !== undefined && row.value !== null && row.value !== 'NULL' && row.value !== "0" && row.value !== 0) ? row.value : ""}</div>,
        classNameGet: 'itemmapfilter1',

    },
    {
        Header: <div style={{ textAlign: 'left' }} >Company ID</div>,
        accessor: 'cid',
        Cell: row => <div style={{ textAlign: "left", paddingLeft: "5px" }} title={(row.value && row.value !== undefined && row.value !== null && row.value !== 'NULL' && row.value !== "0" && row.value !== 0) ? row.value : ""}>{(row.value && row.value !== undefined && row.value !== null && row.value !== 'NULL' && row.value !== "0" && row.value !== 0) ? row.value : ""}</div>,
        classNameGet: 'itemmapfilter1',

    },
    {
        Header: <div style={{ textAlign: 'left' }} >RLB ITEM GROUP</div>,
        accessor: 'rlb_item_group',
        Cell: row => <div style={{ textAlign: "left", paddingLeft: "5px" }}>{(row.value && row.value !== undefined && row.value !== null && row.value !== 'NULL' && row.value !== "0" && row.value !== 0) ? row.value : ""}</div>,
        classNameGet: 'itemmapfilter2'
    },
    {
        Header: <div style={{ textAlign: 'left' }} >RLB ITEM CODE</div>,
        accessor: 'rlb_item_code',
        Cell: row => <div style={{ textAlign: "left", paddingLeft: "5px", }} title={(row.value && row.value !== undefined && row.value !== null && row.value !== 'NULL' && row.value !== "0" && row.value !== 0) ? row.value : ""}>{(row.value && row.value !== undefined && row.value !== null && row.value !== 'NULL' && row.value !== "0" && row.value !== 0) ? row.value : ""}</div>,
        classNameGet: 'itemmapfilter3',

    },
    {
        Header: <div style={{ textAlign: 'left' }} >RLB ITEM NAME</div>,
        accessor: 'rlb_item_name',
        Cell: row => <div className='ellipsisDiv' style={{ textAlign: "left", paddingLeft: "5px", width: '90%' }}>{(row.value && row.value !== undefined && row.value !== null && row.value !== 'NULL' && row.value !== "0" && row.value !== 0) ? row.value : ""}</div>,
        classNameGet: 'itemmapfilter4'
    },

]